import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClipboardModule } from '@angular/cdk/clipboard';

import {
  NbButtonModule, NbTooltipModule, NbBadgeModule, NbSpinnerModule
} from '@nebular/theme';

import { ImageUploaderComponent } from '../components/image-uploader/image-uploader.component';
import { AudioUploaderComponent } from '../components/audio-uploader/audio-uploader.component';
import { DocumentUploaderComponent } from '../components/document-uploader/document-uploader.component';

//Pipes
import { TxtMapTranslatePipe } from '../_pipes/txtmap-translate.pipe';
import { TimeAgoPipe } from '../_pipes/timeago.pipe';
import { ObjectImagePipe } from '../_pipes/object-image.pipe';

//Translations
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"})
    }),
    ClipboardModule,
    NbButtonModule,
    NbTooltipModule,
    NbBadgeModule,
    NbSpinnerModule
  ],
  declarations: [
    ImageUploaderComponent,
    AudioUploaderComponent,
    DocumentUploaderComponent,
    TxtMapTranslatePipe,
    TimeAgoPipe,
    ObjectImagePipe
  ],
  exports: [
    ImageUploaderComponent,
    AudioUploaderComponent,
    DocumentUploaderComponent,
    TranslateModule,
    TxtMapTranslatePipe,
    TimeAgoPipe,
    ObjectImagePipe,
    NbTooltipModule,
    NbBadgeModule,
    NbSpinnerModule
  ]
})
export class SharedModule {}
